import React, { useMemo, useState } from "react";
import {
  USAGE_SECTIONS,
  getUsageCategories,
  getSectionsByCategory,
  getSectionById,
  UsageSection,
} from "./config/usageConfig";

interface SectionGroup {
  category: string;
  sections: UsageSection[];
}

const UsageDocsPage: React.FC = () => {
  const categories = useMemo(() => getUsageCategories(), []);
  const [selectedSectionId, setSelectedSectionId] = useState<string>(
    USAGE_SECTIONS[0]?.id ?? ""
  );

  const groupedSections: SectionGroup[] = useMemo(() => {
    return categories.map((category) => ({
      category,
      sections: getSectionsByCategory(category),
    }));
  }, [categories]);

  const selectedSection = useMemo(
    () => getSectionById(selectedSectionId),
    [selectedSectionId]
  );

  return (
    <div
      style={{
        display: "flex",
        gap: "16px",
        height: "calc(100vh - 120px)",
      }}
    >
      <div
        style={{
          width: "320px",
          borderRight: "1px solid #f0f0f0",
          paddingRight: "16px",
          overflowY: "auto",
        }}
      >
        {groupedSections.map((group) => (
          <div key={group.category} style={{ marginBottom: "24px" }}>
            <div
              style={{
                fontWeight: 600,
                fontSize: "14px",
                marginBottom: "8px",
                color: "#1f1f1f",
              }}
            >
              {group.category}
            </div>
            {group.sections.map((section) => {
              const isActive = section.id === selectedSectionId;
              return (
                <div
                  key={section.id}
                  onClick={() => setSelectedSectionId(section.id)}
                  style={{
                    cursor: "pointer",
                    padding: "10px 12px",
                    borderRadius: "6px",
                    background: isActive ? "#f0f5ff" : "transparent",
                    color: isActive ? "#1d39c4" : "#1f1f1f",
                    marginBottom: "6px",
                    transition: "all 0.2s",
                  }}
                >
                  <div style={{ fontWeight: 500, marginBottom: "4px" }}>
                    {section.title}
                  </div>
                  <div style={{ fontSize: "12px", color: "#8c8c8c" }}>
                    {section.summary}
                  </div>
                </div>
              );
            })}
          </div>
        ))}
      </div>

      <div
        style={{
          flex: 1,
          overflowY: "auto",
          paddingBottom: "32px",
        }}
      >
        {selectedSection ? (
          <div>
            <h2 style={{ marginTop: 0 }}>{selectedSection.title}</h2>
            <p style={{ color: "#595959", lineHeight: 1.6 }}>
              {selectedSection.summary}
            </p>
            <div
              style={{
                marginBottom: "16px",
                fontSize: "14px",
                color: "#1f1f1f",
              }}
            >
              <strong>使用目标：</strong>
              {selectedSection.goal}
            </div>
            {selectedSection.screenshotPlaceholder && (
              <div
                style={{
                  border: "1px dashed #d9d9d9",
                  background: "#fafafa",
                  borderRadius: "8px",
                  padding: "16px",
                  color: "#8c8c8c",
                  marginBottom: "24px",
                  fontSize: "13px",
                }}
              >
                {selectedSection.screenshotPlaceholder}
              </div>
            )}
            <div>
              {selectedSection.steps.map((step, index) => (
                <div key={step.title} style={{ marginBottom: "24px" }}>
                  <div
                    style={{
                      fontWeight: 600,
                      marginBottom: "8px",
                      color: "#1f1f1f",
                    }}
                  >
                    步骤 {index + 1}：{step.title}
                  </div>
                  <div style={{ lineHeight: 1.8 }}>
                    {step.details.map((detail, detailIndex) => {
                      // 如果 detail 是空字符串，渲染为换行
                      if (detail.trim() === "") {
                        return <br key={detailIndex} />;
                      }
                      // 使用 HTML 格式渲染
                      return (
                        <div
                          key={detailIndex}
                          style={{ marginBottom: "8px" }}
                          dangerouslySetInnerHTML={{ __html: detail }}
                        />
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
            {selectedSection.tips && selectedSection.tips.length > 0 && (
              <div
                style={{
                  background: "#fffbe6",
                  border: "1px solid #ffe58f",
                  borderRadius: "6px",
                  padding: "12px 16px",
                  marginTop: "8px",
                }}
              >
                <div
                  style={{
                    fontWeight: 600,
                    marginBottom: "8px",
                    color: "#ad6800",
                  }}
                >
                  小贴士
                </div>
                <div style={{ lineHeight: 1.8 }}>
                  {selectedSection.tips.map((tip, tipIndex) => {
                    // 如果 tip 是空字符串，渲染为换行
                    if (tip.trim() === "") {
                      return <br key={tipIndex} />;
                    }
                    // 使用 HTML 格式渲染
                    return (
                      <div
                        key={tipIndex}
                        style={{ marginBottom: "8px" }}
                        dangerouslySetInnerHTML={{ __html: tip }}
                      />
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        ) : (
          <div style={{ color: "#8c8c8c" }}>请选择左侧的使用说明查看详情。</div>
        )}
      </div>
    </div>
  );
};

export default UsageDocsPage;

